module.exports = __webpack_public_path__ + "57fdec4e2529b2e23b2d8805118840f7.pdf";